import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AceLogger} from '@app/logging/ace-logger';
import {AceLoggerService} from '@app/logging/ace-logger.service';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {CssVariablesService} from '@app/shared/services/util/css-variables.service';
import {RouterLinkConfig} from '@app/shared/util/angular/angular-utils';
import {AppConstants} from "@shared/util/app-constants";


export enum HorizontalAlign {
  LEFT, RIGHT
}

export interface BarConfig {
  id?: any | null;
  color: string;
  value: number;
  tooltip?: I18nMessage | null;
  clickable?: boolean | null;
  routerLinkConfig?: RouterLinkConfig | null;
}


@Component({
  selector: 'app-score-bar',
  templateUrl: './score-bar.component.html',
  styleUrls: ['./score-bar.component.scss'],
  standalone: false
})
export class ScoreBarComponent implements OnChanges {
  @Input() score: number;
  @Input() showScore: boolean = true;
  @Input() scoreBarColor: string;
  @Input() horizontalAlign: HorizontalAlign = HorizontalAlign.RIGHT;
  @Input() barConfigs: BarConfig[] | null = null;
  @Input() clickable = false;
  @Output() barClickEvent = new EventEmitter<BarConfig['id']>;
  total: number | null = null;
  readonly DEFAULT_BAR_COLOR = this.cssVariableService.PRIMARY_COLOR;
  readonly SCORE_PERCENT_FORMAT = AppConstants.SCORE_PERCENT_FORMAT;
  private readonly logger: AceLogger;

  constructor(private cssVariableService: CssVariablesService,
              aceLoggerService: AceLoggerService
  ) {
    this.logger = aceLoggerService.create(ScoreBarComponent.name);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.score && changes.barConfigs) {
      this.logger.error('Expected either score or barConfigs but got both. score: ' + this.score + ' barConfig: ', this.barConfigs);
    }
    if (changes.barConfigs) {
      if (this.barConfigs != null) {
        this.total = this.barConfigs.reduce((total, config) => total + config.value, 0) ?? 0;
        this.showScore = false;
      } else {
        this.total = 0;
      }
    }
    if (changes.score || changes.scoreBarColor || changes.horizontalAlign) {
      if (this.score != null) {
        const scorePercent = this.score * 100;
        this.barConfigs = [
          {id: 'score', value: scorePercent, color: this.scoreBarColor ?? this.DEFAULT_BAR_COLOR},
          {value: 100 - scorePercent, color: 'transparent', clickable: false}
        ];
        this.total = 100;
        if (this.horizontalAlign === HorizontalAlign.RIGHT) {
          this.barConfigs.reverse();
        }
      } else if (!changes.barConfigs) { // In case switched to barConfigs input, do not clear
        this.barConfigs = null;
      }
    }
  }

  onBarClick(id: BarConfig['id']) {
    this.barClickEvent.emit(id);
  }
}
